import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]

import { ref } from "vue";
import { downloadAllOrderLabels } from "@/api/orders";
import { useNotification } from "@/composables/useNotification";


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadAllLabelsButton',
  props: {
    orderId: {},
    labelCount: {}
  },
  setup(__props: any) {

const props = __props;

const isDownloading = ref(false);
const { error: showError } = useNotification();

const downloadAll = async () => {
  if (isDownloading.value) return;
  isDownloading.value = true;
  try {
    const blob = await downloadAllOrderLabels(props.orderId);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `etiquettes-commande-${props.orderId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    showError(
      error instanceof Error
        ? error.message
        : "Impossible de télécharger les étiquettes",
    );
  } finally {
    isDownloading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.labelCount > 1)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        disabled: isDownloading.value,
        class: "mb-4 inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-gray-400",
        onClick: downloadAll
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas mr-2", isDownloading.value ? 'fa-spinner fa-spin' : 'fa-file-pdf'])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(isDownloading.value
        ? "Préparation du PDF..."
        : `Télécharger les ${_ctx.labelCount} étiquettes`), 1)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})